interface ProgressBarProps {
  value: number; // promoTurnover
  max: number; // CAP
  bg?: string;
  bgSuccess?: string;
  rounded?: string;
}

export const ProgressBar = ({
  value,
  max,
  bg = "bg-quaternary-bg",
  bgSuccess = "bg-link",
  rounded = "rounded-full",
}: ProgressBarProps) => {
  const ratio = Math.max(0, Math.min(1, max > 0 ? value / max : 0));
  const width = `${(ratio * 100).toFixed(2)}%`;

  return (
    <div className="w-full flex flex-col gap-1">
      <div className={`w-full h-2 ${rounded} overflow-hidden ${bg}`}>
        <div
          className={`h-full ${value >= max ? bgSuccess : "bg-link"}`}
          style={{ width }}
        />
      </div>
    </div>
  );
};
